import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils';

const fieldClass =
  'block min-h-12 w-full rounded-2xl border border-line bg-surface px-4 text-base text-fg placeholder:text-muted focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-accent aria-invalid:border-danger disabled:opacity-60';

export function Input({ className, ...props }: ComponentProps<'input'>) {
  return <input className={cn(fieldClass, className)} {...props} />;
}

export function Select({ className, ...props }: ComponentProps<'select'>) {
  return <select className={cn(fieldClass, 'pe-8', className)} {...props} />;
}
